import React from "react";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { Label, InputProps } from "reactstrap";

interface FormInputProps extends InputProps {
  name: string;
  label: string;
  error?: string;
  touched?: boolean;
  onChange?: any;
  isAsync?: boolean;
  formGroupClasses?: string;
  placeholder?: string;
  defaultFilter?: any;
}

const FormSelect: React.FC<FormInputProps> = ({
  id,
  name,
  label,
  value,
  error,
  touched,
  isMulti,
  isAsync,
  onChange,
  getOptions,
  options,
  formGroupClasses,
  placeholder,
  defaultFilter,
  isClearable = false,
  getOptionLabel = (row: any) => row.name,
  getOptionValue = (row: any) => row.id,
}) => {
  // const [value, setValue] = useState<any>("");

  async function loadOptions(
    search: any,
    loadedOptions: any,
    { page }: any,
    getOptions: any,
    defaultFilter: any
  ) {
    const response = await getOptions({
      search,
      page,
      limit: 100,
      ...defaultFilter,
    });
    return {
      options: response.data.results,
      hasMore: response.data.page < response.data.totalPages,
      additional: {
        page: page + 1,
      },
    };
  }

  return (
    <div className={formGroupClasses || "mb-3"}>
      {label && (
        <Label
          style={{
            fontSize: "small",
            marginBottom: 4,
          }}
          htmlFor={name}
        >
          {label}
        </Label>
      )}

      <div>
        {isAsync ? (
          <AsyncPaginate
            className={`react-select ${touched && error ? "is-invalid" : ""}`}
            classNamePrefix={"react-select"}
            placeholder={placeholder}
            value={value}
            loadOptions={(search: any, loadedOptions: any, { page }: any) =>
              loadOptions(
                search,
                loadedOptions,
                { page },
                getOptions,
                defaultFilter
              )
            }
            onChange={(value: any) => {
              onChange(name, value);
            }}
            additional={{
              page: 1,
            }}
            isClearable={isClearable}
            isMulti={isMulti}
            menuPortalTarget={document.body}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
          />
        ) : (
          <Select
            id={id}
            name={name}
            className={`react-select ${touched && error ? "is-invalid" : ""}`}
            classNamePrefix={"react-select"}
            placeholder={placeholder}
            value={value}
            options={options}
            onChange={(value) => {
              onChange(name, value);
            }}
            isClearable={isClearable}
            isMulti={isMulti}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
          />
        )}
      </div>

      {touched && error && (
        <small className="text-danger fw-medium">{error}</small>
      )}
    </div>
  );
};

export default FormSelect;
